import React from 'react';
import { FormattedMessage } from 'react-intl';

export const Licenses = {
    MY: {
        SEND_DIRTY_LAUNDRY: (
            <FormattedMessage
                id='Licenses.SEND_DIRTY_LAUNDRY'
                description='Send dirty laundry license'
                defaultMessage='Send dirty laundry'
            />
        )
    },
    LAUNDRY: {
        DEFAULT: (
            <FormattedMessage
                id='Licenses.DEFAULT'
                description='Default laundry license'
                defaultMessage='Laundry'
            />
        ),
        SEND_CLEAN_LAUNDRY: (
            <FormattedMessage
                id='Licenses.SEND_CLEAN_LAUNDRY'
                description='Send clean laundry license'
                defaultMessage='Send clean laundry'
            />
        ),
        RECEIVE_DIRTY_LAUNDRY: (
            <FormattedMessage
                id='Licenses.RECEIVE_DIRTY_LAUNDRY'
                description='Receive dirty laundry license'
                defaultMessage='Receive dirty laundry'
            />
        )
    },
    ANALYTICS: {
        DEFAULT: (
            <FormattedMessage
                id='Licenses.ANALYTICS.DEFAULT'
                description='Default analytics license'
                defaultMessage='Analytics'
            />
        )
    },
    MONITORING: {
        DEFAULT: (
            <FormattedMessage
                id='Licenses.MONITORING.DEFAULT'
                description='Default monitoring license'
                defaultMessage='Monitoring'
            />
        ),
        INFRASTRUCTURE: (
            <FormattedMessage
                id='Licenses.MONITORING.INFRASTRUCTURE'
                description='Infrastructure monitoring license'
                defaultMessage='Infrastructure'
            />
        )
    },
    HARDWARE: {
        ACCESS_CONTROLLERS: (
            <FormattedMessage
                id='Licenses.HARDWARE.ACCESS_CONTROLLERS'
                description='Access controllers hardware license'
                defaultMessage='Access Controllers'
            />
        ),
        GATES: (
            <FormattedMessage
                id='gates'
                defaultMessage='Gates'
            />
        )
    }
};
